import Axios from 'axios';
import { APIBASE_URL, Payment_URL } from '../config/cacheKey';
import { ApiResultModel } from '../models/common.model';
import {
    IGetArrearsPaymentResultRequest, IGetInstallmentsPaymentResponse, IGetInstallmentsPaymentResultRequest, IGetPrePaymentGatewayRequest, IGetPrePaymentGatewayResponse, IGetSentToBankLoanRequestsForCurrentUserResponse, IPayArrearsPaymentRequest,
    IPayArrearsPaymentResponse, IPayInstallmentsPaymentRequest, IPayInstallmentsPaymentResponse,
    IPayLoanPrepaymentRequest,
    IPayLoanPrepaymentRequestResponse
} from '../models/payment.model';
import { IGetWaitForCustomerApproveSalesResponse } from '../models/sale.model';






export const PayArrearsPayment = (data: IPayArrearsPaymentRequest): Promise<IPayArrearsPaymentResponse> => {
    return Axios.post<ApiResultModel<IPayArrearsPaymentResponse>>(
        APIBASE_URL + Payment_URL + '/PayArrearsPayment',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetArrearsPaymentResult = (data: IGetArrearsPaymentResultRequest): Promise<ApiResultModel<IGetWaitForCustomerApproveSalesResponse>> => {
    return Axios.get<ApiResultModel<IGetWaitForCustomerApproveSalesResponse>>(
        APIBASE_URL + Payment_URL + "/GetArrearsPaymentResult/" + data.gatewayPaymentToken
    ).then((result) => {
        return result.data;
    });
};
export const GetSentToBankLoanRequestsForCurrentUser = (): Promise<IGetSentToBankLoanRequestsForCurrentUserResponse[]> => {
    return Axios.get<ApiResultModel<IGetSentToBankLoanRequestsForCurrentUserResponse[]>>(
        APIBASE_URL + Payment_URL + "/GetSentToBankLoanRequestsForCurrentUser"
    ).then((result) => {
        return result.data.data;
    });
};
export const GetArrearsPaymentsForCurrentUser = (): Promise<IGetWaitForCustomerApproveSalesResponse> => {
    return Axios.get<ApiResultModel<IGetWaitForCustomerApproveSalesResponse>>(
        APIBASE_URL + Payment_URL + "/GetArrearsPaymentsForCurrentUser"
    ).then((result) => {
        return result.data.data;
    });
};


export const PayInstallmentsPayment = (data: IPayInstallmentsPaymentRequest): Promise<IPayInstallmentsPaymentResponse> => {
    return Axios.post<ApiResultModel<IPayInstallmentsPaymentResponse>>(
        APIBASE_URL + Payment_URL + '/PayInstallmentsPayment',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetInstallmentsPaymentResult = (data: IGetInstallmentsPaymentResultRequest): Promise<ApiResultModel<IGetInstallmentsPaymentResponse>> => {
    return Axios.get<ApiResultModel<IGetInstallmentsPaymentResponse>>(
        APIBASE_URL + Payment_URL + "/GetInstallmentsPaymentResult/" + data.gatewayInstallmentsPaymentToken
    ).then((result) => {
        return result.data;
    });
};

export const PayLoanPrepayment = (data: IPayLoanPrepaymentRequest): Promise<IPayLoanPrepaymentRequestResponse> => {
    return Axios.post<ApiResultModel<IPayLoanPrepaymentRequestResponse>>(
        APIBASE_URL + Payment_URL + '/PayLoanPrepayment',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetPrePaymentGatewayResult = (data: IGetPrePaymentGatewayRequest): Promise<ApiResultModel<IGetPrePaymentGatewayResponse>> => {
    return Axios.post<ApiResultModel<IGetPrePaymentGatewayResponse>>(
        APIBASE_URL + Payment_URL + '/GetPrePaymentGatewayResult',
        data
    ).then((result) => {
        return result.data;
    });
}
